"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    VERTICAL: 'orientation-vertical',
    HORIZONTAL: 'orientation-horizontal',
};
//# sourceMappingURL=orientations.js.map